import { createStore } from "vuex";
import ships from "./modules/ships";
import user from "./modules/user";

const store = createStore({
  modules: {
    ships,
    user,
  },
  state: {
    stateForm: true,
    stateFormConfigEdit: false,
    language: "es",
  },
  getters: {
    state(state) {
      return state;
    },
    someGetter: (state, getters, rootState, rootGetters) => {
      //...
      rootGetters.someOtherGetter;
      rootGetters["bar/someOtherGetter"];
      //...
    },
    stateForm(state) {
      return state.stateForm;
    },
    stateFormConfigEdit(state) {
      return state.stateFormConfigEdit;
    },
    languageState(state) {
      return state.language;
    }
  },
  mutations: {
    SET_FORM_STATE(state, value) {
      state.stateForm = value;
      console.log("FormEdit New Ship.-", state.stateForm);
    },
    SET_FORM_CONFIG_EDIT(state, value) {
      state.stateFormConfigEdit = value;
    },
    SET_LANGUAGE_STATE(state, value) {
      state.language = value;
      console.log("SET_LANGUAGE_STATE .-", value);
    },
  },
  actions: {},
});

export default store;
